"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = share;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

var _nativeShare = require("./nativeShare");

var _wechat = _interopRequireDefault(require("../wechat"));

var _utils = _interopRequireDefault(require("../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var init = _wechat.default.init;
var isApp = _utils.default.isApp;
/**
 * 分享
 * 入参:
 * {}
 *  {String} {required} title：分享标题
 *  {String} {required} text：分享描述
 *  {String} {required} imageUrl：分享图标
 *  {String} url：分享链接，默认当前链接
 *  {Function} cancel：分享取消
 *  {Function} success：分享成功
 *  {Function} click：分享点击 app专用
 *  {Object} shareInfo：分享配置 app专用
 *  {Array} platforms：分享平台，默认['Wechat', 'WechatMoments', 'QQ', 'QZone'] app专用
 */

function share(opts) {
  if (isApp()) {
    return (0, _nativeShare.nativeShare)(_objectSpread({
      shareSuccess: opts.success
    }, opts));
  }

  return init(_objectSpread({
    link: opts.url || window.location.href,
    desc: opts.text,
    imgUrl: opts.imageUrl,
    error: opts.cancel
  }, opts));
}